import { useQuery } from '@tanstack/react-query';
import { api } from '../../../services/api.js';

interface StreakData {
  currentStreak: number;
  longestStreak: number;
  lastActiveDate: string;
}

interface ProfileData {
  xp: number;
  level: number;
  displayName?: string;
}

interface BadgeData {
  badgeId: string;
  unlockedAt: string;
}

/** Fila diaria de actividad tal como la devuelve GET /gamification/activity. */
export interface ActivityDay {
  date: string;
  notesCreated: number;
  notesEdited: number;
  pagesRead: number;
  lessonsCompleted: number;
  total: number;
}

// El backend otorga XP/badges/racha de forma async (eventos, hasta ~30s):
// refrescamos las queries de gamificación cada 30s y tras las mutaciones.
const REFETCH_INTERVAL = 30_000;

export function useStreak() {
  return useQuery<StreakData>({
    queryKey: ['gamification', 'streak'],
    queryFn: () => api.get<StreakData>('/gamification/streak'),
    staleTime: 1000 * 60 * 5,
    refetchInterval: REFETCH_INTERVAL,
  });
}

export function useProfile() {
  return useQuery<ProfileData>({
    queryKey: ['gamification', 'profile'],
    queryFn: () => api.get<ProfileData>('/profile'),
    staleTime: 1000 * 60 * 5,
    refetchInterval: REFETCH_INTERVAL,
  });
}

export function useBadges() {
  return useQuery<BadgeData[]>({
    queryKey: ['gamification', 'badges'],
    queryFn: () => api.get<BadgeData[]>('/gamification/badges'),
    staleTime: 1000 * 60 * 5,
    refetchInterval: REFETCH_INTERVAL,
  });
}

export function useActivityStats(days = 30) {
  return useQuery<ActivityDay[]>({
    queryKey: ['gamification', 'activity', days],
    queryFn: () => api.get<ActivityDay[]>('/gamification/activity', { days: String(days) }),
    staleTime: 1000 * 60 * 5,
    refetchInterval: REFETCH_INTERVAL,
  });
}
